export default "__VITE_ASSET__BkH_yBT0__"